import { ModalBody, ModalBodyProps } from '@chakra-ui/react';
import React from 'react';

export const CmModalBody: React.FC<ModalBodyProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <ModalBody {...rest}>{children}</ModalBody>;
};
